import CreatorLayout from "@/components/CreatorLayout";
import ShoppingListContainer from "@/components/ShoppingList/ShoppingListContainer";
import craft from "@/lib/craft";
import QueryChefs from "@/queries/QueryChefs.graphql";
import ChefPage from "@/src/chefs/components/ChefPage";
import getChefStaticProps from "@/src/chefs/lib/getChefStaticProps";
import { observer } from "mobx-react";
import Head from "next/head";
import { Seomatic } from "react-seomatic";

export async function getStaticPaths() {
  const queries = [
    {
      document: QueryChefs,
    },
  ];

  const response = await craft(queries);

  const { chefs } = response[0];

  const paths = chefs.map((chef) => ({
    params: {
      slug: chef.slug,
      pageNumber: 1,
    },
  }));

  return {
    paths: [],
    fallback: "blocking",
  };
}

export async function getStaticProps({ params, previewData, preview }) {
  const chefPageStaticProps = getChefStaticProps({
    slug: params.slug,
    pageNumber: params.pageNumber,
  });

  return chefPageStaticProps;
}

const ChefPagePage = ({ pageEntry, pageCount, pageNumber, chef, recipes }) => {
  return (
    <>
      <Seomatic Head={Head} {...chef.seomatic} />
      <ShoppingListContainer hideOnScroll />

      <ChefPage
        chef={chef}
        recipes={recipes}
        pageCount={pageCount}
        pageNumber={pageNumber}
      />
    </>
  );
};

ChefPagePage.getLayout = (page) => {
  const { props } = page;
  const { notifications, navigation, colourway, chefs, chef } = props;

  return (
    <CreatorLayout
      notifications={notifications}
      colourway={colourway}
      creators={chefs}
      creator={chef}
      navigation={navigation}
      heading="Our Chefs"
      headingHref="/chefs"
    >
      {page}
    </CreatorLayout>
  );
};

export default observer(ChefPagePage);
